import type { MatIconDefaultOptions } from '@angular/material/icon';

export const appMatIconConfig: MatIconDefaultOptions = {
  fontSet: 'material-symbols-outlined',
};
